<template>
  <div class="marquee">
    <h2 class="marquee-title">最新申请动态</h2>
    <div class="animate-box">
      <div class="animate">
        <p v-for="(item, index) in dataList" :key="index">
          {{ formatDate(item.CreateTime) }} {{ item.owner_name }} 预授信额度审批：{{ item.amt_ysx }}万元
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import request from '@/assets/js/request';
export default {
  name: 'marquee-text',
  data() {
    return {
      dataList: [],
      timer: null
    };
  },
  mounted() {
    this.getApply();
    setInterval(() => {
      this.getApply();
    }, 38000);
  },
  beforeDestroy() {
    this.timer && clearInterval(this.timer);
  },
  methods: {
    formatDate(val) {
      let value = val.toString();
      return `${value.substr(4, 2)}月${value.substr(6, 2)}日 ${value.substr(8, 2)}:${value.substr(10, 2)}:${value.substr(12, 2)}`;
    },
    getApply() {
      request({
        url: '/api/rpt/apply/last/top'
      }).then(res => {
        if (res.success) {
          this.dataList = res.result;
        }
      });
    }
  }
};
</script>

<style scoped>
.marquee {
  width: 100%;
  margin: 0 auto;
  height: 180px;
  box-sizing: border-box;
  padding: 0 10px 10px 10px;
  border-radius: 4px;
  background: rgba(58, 94, 194, 0.2);
}
.marquee-title {
  background: url('../assets/image/notice.png') no-repeat;
  background-size: 16px;
  background-position: 0 50%;
  text-align: lefr;
  padding: 20px;
  font-weight: bold;
  font-size: 16px;
}
.animate-box {
  overflow: hidden;
  height: calc(100% - 56px);
}

.animate {
  width: 100%;
  font-size: 14px;
  color: #15caf9;
  display: inline-block;
  white-space: nowrap;
  letter-spacing: 0;
  animation: 40s wordsLoop linear infinite normal;
}

.animate p {
  padding: 10px 0;
  white-space: normal;
}

@-webkit-keyframes wordsLoop {
  0% {
    transform: translateY(0);
  }

  100% {
    transform: translateY(-100%);
    -webkit-transform: translateY(-100%);
  }
}
</style>
